import { almostZero, Currency, numberFormat } from "@xola/ui-kit";
import { PurchaseItemStatus } from "common";
import { isNil } from "lodash";
import { LineItem, LineItemType, PurchaseItem } from "types";
import { useLocalizationStore } from "@/stores/localizationStore";
import { getSeller } from "@/utils/getSeller";

export const getColor = (lineItem: LineItem, item?: PurchaseItem) => {
    const previousLineItem = item?.lineItems.find((item: LineItem) => item.id === lineItem.id);
    const isItemAmountChanged = previousLineItem && previousLineItem.amount !== lineItem.amount;
    const isNew = !lineItem.createdAt;

    if (!previousLineItem && item) {
        return "primary";
    }

    if (!item) {
        return isNew ? "primary" : "default";
    }

    return isItemAmountChanged ? "primary" : "default";
};

export const getPriceAndQuantity = (lineItem: LineItem) => {
    const seller = getSeller();
    const locale = useLocalizationStore.getState().getLocale();
    const currency = seller?.currency ?? Currency.USD;

    let price = lineItem.price;
    if (isNil(price) && lineItem.amount && lineItem.quantity && lineItem.quantity > 1) {
        price = lineItem.amount / lineItem.quantity;
    }

    const amount = numberFormat(price, currency, locale);

    const priceAndQuantity =
        lineItem.price || lineItem.type === LineItemType.ADDON ? [amount, "×", lineItem.quantity ?? 1].join(" ") : null;

    return priceAndQuantity ? `(${priceAndQuantity})` : null;
};

export const getAddonColor = (lineItem: LineItem, item?: PurchaseItem) => {
    const previousLineItemQuantity = item?.lineItems.find((item: LineItem) => item.id === lineItem.id);
    if (!previousLineItemQuantity) {
        return "primary";
    }

    return previousLineItemQuantity?.amount === lineItem.amount ? "default" : "primary";
};

// Hide only when nothing is paid and every item is declined: one declined MIST item must not hide Apply Code for the rest
export const canShowPaidDetails = (items: PurchaseItem[], paid: number) => {
    return !almostZero(paid) || items.some((item) => item.status !== PurchaseItemStatus.DECLINED);
};
